import React from 'react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

const PublishConfirmationModal = ({ show, handleClose, store }) => {
    const publishTemplate = (publish = true) => {
        store.publishTemplateSurvey(publish)
        handleClose()
    }

    const { isTemplatePublished } = store.survey.metadata

    return (
        <Modal
            show={show}
            onClose={handleClose}
        >
            <div id="confirm-publish-modal">
                <div className="uc-modal__header">
                    <h2>{i18n.t('gen_are_you_sure')}</h2>
                    <p className="uc-modal__desc">
                        {i18n.t(`surveyBuilder.modal.confirm.${isTemplatePublished ? 'unpublish' : 'publish'}`)}
                    </p>
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        onClick={handleClose}
                        cssClass="tertiary"
                        label={i18n.t('cancel')}
                    />
                    <Button
                        onClick={isTemplatePublished
                            ? () => publishTemplate(false)
                            : () => publishTemplate()}
                        cssClass="secondary"
                        label={i18n.t(`surveyBuilder.banner.${isTemplatePublished
                            ? 'unpublishTemplate'
                            : 'publishTemplate'
                        }`)}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default PublishConfirmationModal
